export default __webpack_public_path__ + "static/media/lattice_logo_nest_color.cbb793f6.svg";